import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './age-by-single-year-of-age.reducer';

export const AgeBySingleYearOfAgeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const ageBySingleYearOfAgeEntity = useAppSelector(state => state.ageBySingleYearOfAge.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="ageBySingleYearOfAgeDetailsHeading">
          <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.detail.title">AgeBySingleYearOfAge</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.id}</dd>
          <dt>
            <span id="geographicLevel">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.geographicLevel">Geographic Level</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.geographicLevel}</dd>
          <dt>
            <span id="date">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.date">Date</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.date}</dd>
          <dt>
            <span id="geography">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.geography">Geography</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.geography}</dd>
          <dt>
            <span id="geographyCode">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.geographyCode">Geography Code</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.geographyCode}</dd>
          <dt>
            <span id="totalValue">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.totalValue">Total Value</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.totalValue}</dd>
          <dt>
            <span id="aged4AndUnder">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged4AndUnder">Aged 4 And Under</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged4AndUnder}</dd>
          <dt>
            <span id="underOneYear">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.underOneYear">Under One Year</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.underOneYear}</dd>
          <dt>
            <span id="aged1Year">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged1Year">Aged 1 Year</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged1Year}</dd>
          <dt>
            <span id="aged2Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged2Years">Aged 2 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged2Years}</dd>
          <dt>
            <span id="aged3Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged3Years">Aged 3 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged3Years}</dd>
          <dt>
            <span id="aged4Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged4Years">Aged 4 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged4Years}</dd>
          <dt>
            <span id="aged5To9Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged5To9Years">Aged 5 To 9 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged5To9Years}</dd>
          <dt>
            <span id="aged10To15Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged10To15Years">Aged 10 To 15 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged10To15Years}</dd>
          <dt>
            <span id="aged16To19Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged16To19Years">Aged 16 To 19 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged16To19Years}</dd>
          <dt>
            <span id="aged20To24Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged20To24Years">Aged 20 To 24 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged20To24Years}</dd>
          <dt>
            <span id="aged25To34Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged25To34Years">Aged 25 To 34 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged25To34Years}</dd>
          <dt>
            <span id="aged35To49Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged35To49Years">Aged 35 To 49 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged35To49Years}</dd>
          <dt>
            <span id="aged50To64Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged50To64Years">Aged 50 To 64 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged50To64Years}</dd>
          <dt>
            <span id="aged65To74Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged65To74Years">Aged 65 To 74 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged65To74Years}</dd>
          <dt>
            <span id="aged75To84Years">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged75To84Years">Aged 75 To 84 Years</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged75To84Years}</dd>
          <dt>
            <span id="aged85AndOver">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged85AndOver">Aged 85 And Over</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged85AndOver}</dd>
          <dt>
            <span id="aged100AndOver">
              <Translate contentKey="apiLocationApp.ageBySingleYearOfAge.aged100AndOver">Aged 100 And Over</Translate>
            </span>
          </dt>
          <dd>{ageBySingleYearOfAgeEntity.aged100AndOver}</dd>
        </dl>
        <Button tag={Link} to="/age-by-single-year-of-age" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/age-by-single-year-of-age/${ageBySingleYearOfAgeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default AgeBySingleYearOfAgeDetail;
